import React from 'react';
import { useNavigate } from "react-router-dom";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import styles from './style.module.css';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PsychologyIcon from '@mui/icons-material/Psychology';
import CategoryIcon from '@mui/icons-material/Category';
import CodeIcon from '@mui/icons-material/Code';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import CachedIcon from '@mui/icons-material/Cached';
import VideocamIcon from '@mui/icons-material/Videocam';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import HubIcon from '@mui/icons-material/Hub';

export default function App() {
  const navigate = useNavigate();
  const managements = [
    {
      "icon": <LocationOnIcon/>,
      "name": "Site Management",
      "management_id": "site_management",
      "description": "Manage robot sites",
    },
    {
      "icon": <PsychologyIcon/>,
      "name": "AI Management",
      "management_id": "ai_management",
      "description": "Manage robot AI configuration",
    },
    {
      "icon": <CategoryIcon/>,
      "name": "Type Management",
      "management_id": "type_management",
      "description": "Manage the type of robots",
    },
    {
      "icon": <CodeIcon/>,
      "name": "Software Management",
      "management_id": "software_management",
      "description": "Manage the version of the robot software",
    },
    {
      "icon": <CompareArrowsIcon/>,
      "name": "Endpoint Management",
      "management_id": "endpoint_management",
      "description": "Manage the endpoint of the robots",
    },
    {
      "icon": <CachedIcon/>,
      "name": "Robot Version Management",
      "management_id": "robot_version_management",
      "description": "Manage versions of the robots",
    },
    {
      "icon": <VideocamIcon/>,
      "name": "Robot Camera Management",
      "management_id": "robot_livestream_management",
      "description": "Manage robot's cameras and livestreams",
    },
    {
      "icon": <ReportProblemIcon/>,
      "name": "Status Code Management",
      "management_id": "status_code_management",
      "description": "Manage status codes of the robots",
    },
    {
      "icon": <Inventory2Icon/>,
      "name": "Payload Management",
      "management_id": "payload_management",
      "description": "Manage payload APIs and workflows",
    },
    {
      "icon": <HubIcon/>,
      "name": "Integration Management",
      "management_id": "integration_management",
      "description": "Manage platform integrations and actions",
    },
  ]
  // console.log("TOKEN IN DASHBOARD APP "+keycloak.token)

  const handleManagementPage = (management) => {
    navigate(`/managements/${management.management_id}`)
  };

  const renderManagements = (management, index) =>{
    // console.log(robotStatus)
    // console.log(robot)
    return(
    <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={index} style={{paddingRight: 15, paddingBottom: 15}}>
      <Box
        onClick={() => handleManagementPage(management)}
        sx={{
          height: 100,
          width: '100%',
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'row',
          cursor: 'pointer',
          transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
          '&:hover': {
            borderColor: 'primary.main',
            boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 0.2, height: '100%', color: 'text.secondary' }}>
          {management.icon}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'start', justifyContent: 'center', flexDirection: 'column', flex: 0.8 }}>
          <div className={styles.font} style={{fontSize: 20}}>{management.name}</div>
          <div className={styles.subfont} style={{fontSize: 15}}>{management.description}</div>
        </Box>
      </Box>
    </Grid>)
  }
  return (
    <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column"}}>
      <p className={styles.header_font} style={{marginLeft: 15, fontSize: 50}}>Managements</p>
      <Grid container style={{paddingLeft: 15}}>
      {managements.length > 0 ?
      managements.map((management, index) => (renderManagements(management, index)))
      : null}
      </Grid>
    </div>
  );
}
